/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Icon, ToolTip } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/organize/toggle/toggle_styles';



/* ========== ~~~~~~~~~~ EMBED ORGANZIE : CUSTOM TOGGLE ~~~~~~~~~~ ========== */
class Toggle extends Component {
    handleClick = () => {
        this.props.live ? this.props.toggleMethods.liveToNotLive(this.props.index) : this.props.toggleMethods.notLiveToLive(this.props.index);
    }
    renderSymbol() {
        return this.props.live ? <Icon name={`times-circle`} klass={`remove`} /> : <Icon name={`plus-circle`} klass={`add`} />;
    }
    render() {
        return (
            <ToolTip position={`top`} action={`mouseenter`} content={this.props.live ? 'Remove from Embed' : 'Add to Embed'}>
                <div className={`toggle ${this.props.classes.toggle} ${this.props.position}`} onClick={this.handleClick} >
                    {this.renderSymbol()}
                </div>
            </ToolTip>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Toggle);
